import React from "react";
import { NavigationLinks, Section, Text } from "../../../../components";
import { Banner, SegurosCards } from "../../sections";
import { ReactComponent as ImageNavigationLinks } from "../../../../assets/images/habitacional/ilustracao-casa-habitacional.svg";

const CoberturasAssistenciasPage = () => {
  return (
    <>
      <Banner
        contentWidth={{
          lg: 11,
          xl: 11,
        }}
        sectionName="Banner da pagina de coberturas e assistencias"
        descricao={
          <>
            <Text>
              As coberturas servem para gente te pagar uma indenização e cuidar
              do seu imóvel quando um imprevisto (sinistro) acontecer. Já as
              assistências são serviços para facilitar o seu dia a dia.
            </Text>
            <Text>
              Escolha o seu produto e veja o que tem disponível pra você.
            </Text>
          </>
        }
      />
      <Section as={SegurosCards} sectionName="Cards dos tipos de seguros" />
      <Section
        as={NavigationLinks}
        sectionName="Ainda podemos te ajudar?"
        sectionTitle="Ainda podemos te ajudar?"
        image={<ImageNavigationLinks />}
      />
    </>
  );
};

CoberturasAssistenciasPage.propTypes = {};

export default CoberturasAssistenciasPage;
